import { render, staticRenderFns } from "./AddLabelModal.vue?vue&type=template&id=c4e45ed2&scoped=true"
import script from "./AddLabelModal.vue?vue&type=script&lang=js"
export * from "./AddLabelModal.vue?vue&type=script&lang=js"
import style0 from "./AddLabelModal.vue?vue&type=style&index=0&id=c4e45ed2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e45ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4e45ed2')) {
      api.createRecord('c4e45ed2', component.options)
    } else {
      api.reload('c4e45ed2', component.options)
    }
    module.hot.accept("./AddLabelModal.vue?vue&type=template&id=c4e45ed2&scoped=true", function () {
      api.rerender('c4e45ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/AddLabelModal.vue"
export default component.exports